@if (!httpError) {
  <div id="content-documentation" class="row documentation">
    @if (documentation) {
      <div class="col-12">
        <div class="col-12">
          <section class="row">
            <h3 class="h-main h-main-medium corporate col-12 no-pd">
              {{ 'document_documents_must_attach' | translate }}
              <span class="recipient-data">
                <a class="icon-a" href="javascript:void(0)" (click)="openModalGeneric()">
                  <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
                </a>
              </span>
            </h3>

            @if (status === listStatus.attachDocumentation) {
              <div class="col-12 no-pd upload-msg">
                <div class="row">
                  <div class="col-md-8">
                    <p>{{ 'documentation_send_your_manager_info' | translate }}</p>
                  </div>
                  <div class="col-md-4">
                    <a
                      id="documentation-btn-finish-upload"
                      class="filled btn btn-02 send-agent"
                      href="javascript:;"
                      (click)="canFinishUpload()"
                      >{{ 'documentation_send_your_manager_btn' | translate }}</a
                    >
                  </div>
                </div>
              </div>
            }

            <div class="document-category" *ngFor="let documentCategory of documentation">
              <h4 class="h-main h-main-medium">{{ documentCategory?.name | translate }}</h4>
              <app-document
                [listDocuments]="documentCategory?.firstHolder"
                [name]="firstHolder"
                [filesNotType]="filesNotType"
              ></app-document>

              @if (documentCategory?.secondHolder.length > 0) {
                <app-document
                  [listDocuments]="documentCategory?.secondHolder"
                  [name]="secondHolder"
                  [filesNotType]="filesNotType"
                ></app-document>
              }
              <app-document
                [listDocuments]="documentCategory?.common"
                [filesNotType]="filesNotType"
                [name]="titleFilesCommon"
              ></app-document>
            </div>
          </section>
        </div>
      </div>
    }
  </div>
}
